
<div>

    <app-component-selector 
        [campusId]="this.campus.campusId" 
        [editionId]="0"
        [webResourceId]="this.webResourceId">
    </app-component-selector>

    <div class="container-fluid px-3 py-3">
    
        <div class="row">

            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                <app-contact-data [campus]="this.campus"></app-contact-data>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                <app-contact-form [campus]="this.campus"></app-contact-form>
            </div>

        </div>

    </div>

</div>